import { Injectable } from '@angular/core';
import { IPermissionsService } from 'src/app/shared/authorization/permissions.service.interface';
import { MaintenancePermissionsService } from './maintenance/maintenance-permissions.service';

@Injectable()
export class PermissionsService implements IPermissionsService {
  private _permissionServices: IPermissionsService[] = [];

  constructor(maintenancePermissionsService: MaintenancePermissionsService) {
    this._permissionServices.push(maintenancePermissionsService);
  }

  public hasPermission(operation: string): boolean {
    return this._permissionServices.find((ps) => ps.hasPermission(operation)) != null;
  }
}
